import React from 'react';
import { capitalize } from 'lodash';
import cn from 'classnames';
import { generatePath, Link } from 'react-router-dom';
import { useAppSelector, useTranslation } from 'client/hooks';

import Icon from '../Icon';

import {
  CONTACT_US_PAGE_ROUTE,
  FAQ_PAGE_ROUTE,
  ADD_YOUR_COMPANY_PAGE_ROUTE,
  MAIN_PAGE_ROUTE,
  TERMS_OF_USE_PAGE_ROUTE,
  PRIVACY_POLICY_PAGE_ROUTE,
  DISCLAIMER_PAGE_ROUTE,
  CYBER_SECURITY_PAGE_ROUTE,
  ACCESSIBILITY_STATETMENT_PAGE_ROUTE,
  CLUB_PAGE_ROUTE,
  ABOUT_PAGE_ROUTE,
} from 'client/constants/routes';
import { selectLang } from 'client/redux/settings/selectors';

import logo from 'client/assets/header/cic-logo-v2.svg';

import css from './Footer.module.scss';

const SOCIALS_LINKS = {
  linkedin: 'https://www.linkedin.com/company/catalyst-investors-club/',
  facebook: 'https://www.facebook.com/',
};

const Footer = () => {
  const { translate } = useTranslation();
  const lang = useAppSelector(selectLang);
  const year = new Date().getFullYear();

  const menuLinks = [
    { name: 'aboutUs', link: generatePath(ABOUT_PAGE_ROUTE, { lang }) },
    { name: 'clubPage', link: generatePath(CLUB_PAGE_ROUTE, { lang }) },
    { name: 'faq', link: generatePath(FAQ_PAGE_ROUTE, { lang }) },
    { name: 'addYourCompany', link: generatePath(ADD_YOUR_COMPANY_PAGE_ROUTE, { lang }) },
    { name: 'contactUs', link: generatePath(CONTACT_US_PAGE_ROUTE, { lang }) },
  ];

  const staticPages = [
    {
      name: 'termsAndConditions',
      link: generatePath(TERMS_OF_USE_PAGE_ROUTE, { lang }),
    },
    {
      name: 'accessibilityStatetment',
      link: generatePath(ACCESSIBILITY_STATETMENT_PAGE_ROUTE, { lang }),
    },
    {
      name: 'privacyPolicy',
      link: generatePath(PRIVACY_POLICY_PAGE_ROUTE, { lang }),
    },
    {
      name: 'disclaimers',
      link: generatePath(DISCLAIMER_PAGE_ROUTE, { lang }),
    },
    {
      name: 'cyberCecurity',
      link: generatePath(CYBER_SECURITY_PAGE_ROUTE, { lang }),
    },
  ];

  return (
    <footer>
      <div className={css.footerInner}>
        <div className={css.leftPart}>
          <div className={css.logoWrapper}>
            <Link to={MAIN_PAGE_ROUTE.replace(':lang', lang)} className={css.logo}>
              <img src={logo} alt="Catalyst Investors Club" />
            </Link>
            {/* <div className={css.divider}></div>
            <div className={css.logoText}>{translate('header.logoText')}</div> */}
          </div>
          <div
            className={css.copyrightText}
            dangerouslySetInnerHTML={{ __html: translate('footer.copyRightText').replace('{year}', `${year}`) }}
          ></div>
        </div>
        <div className={css.menu}>
          <div className={css.links}>
            {menuLinks.map((link) => {
              const linkUrl = link.link.replace(':lang', lang);

              return (
                <Link to={linkUrl} key={`${linkUrl}`} className={cn(css.navLink)}>
                  <span>{capitalize(translate(`footer.menuItems.${link.name}`))}</span>
                </Link>
              );
            })}
          </div>
          <div className={css.docs}>
            {staticPages.map((link) => {
              return (
                <Link to={link.link} key={link.name} className={cn(css.docLink)}>
                  <span>{capitalize(translate(`footer.menuItems.${link.name}`))}</span>
                </Link>
              );
            })}
          </div>
        </div>
        <div className={css.footerSocials}>
          <a href={SOCIALS_LINKS.linkedin} target="_blank" rel="noreferrer">
            <Icon type="linkedin" />
          </a>
          {/* <a href={SOCIALS_LINKS.facebook} target="_blank" rel="noreferrer">
            <Icon type="facebook" />
          </a> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
